var React = require( 'react' );
var createReactClass = require('create-react-class');
var CheckBoxItem = require('./checkBoxItem.jsx');

function convertImageUrl( x ) {
  if ( x.indexOf( 'local:image:' ) === 0 ) {
    return 'https://res.cloudinary.com/mytotalhealth/image/upload/q_auto/survey/' + x.substring( 12 ).replace(/@/g, '_');
  } else {
    return x;
  }
}

var CheckboxList = createReactClass({
     render: function() {
        var mappedInputElements = this.props.choices.map(function(choice, key) {
            var userResponse = {};
            for(var i = 0; i < this.props.currentResponse.length; i++){
                if(choice.tag + '_' + choice.value === this.props.currentResponse[i].tag + '_' + this.props.currentResponse[i].value){
                    userResponse = this.props.currentResponse[i];
                    break;
                }
            }

            var disabled = false;
            if(this.props.enableOnlyChoicesFrom){
                disabled = true;

                this.props.priorResponse.forEach(function(x){
                    if(choice.tag + '_' + choice.value === x.tag + '_' + x.value){
                        disabled = false;
                    }
                });

                // the last choice should not be disabled (follow the logic of iOS app here); tag: not_have_symptoms
                if(this.props.choices.length - 1 === key){
                    disabled = false;
                }
            }

            return (
              <CheckBoxItem
                choice={choice}
                key={this.props.name + '-choice-' + key}
                userResponse={userResponse}
                allowMulti={this.props.allowMulti}
                disabled={disabled}
                handleResponse={this.props.response} />
            );
        }.bind(this));

        return (
            <div className="inputFieldWrapper">
                {this.props.imageUrl && (
                    <img src={ convertImageUrl(this.props.imageUrl) } alt="" />
                )}
                <ul className="multiple-choice no-bullet clearfix">
                    {mappedInputElements}
                </ul>
            </div>
        );
    }
});

module.exports = CheckboxList;



// WEBPACK FOOTER //
// ./src/common/routes/survey/components/field-types/select/checkBoxList.jsx